import { render, staticRenderFns } from "./DefineCategories.vue?vue&type=template&id=3fdb8558&"
import script from "./DefineCategories.vue?vue&type=script&lang=js&"
export * from "./DefineCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports